<script setup lang="ts">
import { Users } from 'lucide-vue-next';

import { cn } from '@/lib/utils';

import type { HTMLAttributes } from 'vue';

withDefaults(
  defineProps<{
    class?: HTMLAttributes['class'];
    groupDetailsClass?: HTMLAttributes['class'];
    name?: string;
    description?: string;
    truncate?: boolean;
    isSmall?: boolean;
    isOption?: boolean;
  }>(),
  {
    class: null,
    groupDetailsClass: null,
    name: '',
    description: '',
    truncate: false,
    isSmall: false,
    isOption: false
  }
);
</script>

<template>
  <div
    :data-id="`group-info-block-${name}`"
    :class="cn('flex gap-2.5', $props.class)"
    data-testid="group-info-block"
  >
    <div
      class="shrink-0 bg-white border border-gray-200 rounded-md justify-center items-center w-7 h-7 inline-flex pointer-events-none"
    >
      <Users class="w-4 h-4 shrink-0 stroke-gray-500 stroke-2" />
    </div>
    <div :class="groupDetailsClass">
      <p
        :title="name"
        data-testid="group-info-block-name"
        :class="
          cn(
            'text-xs font-semibold text-gray-800 break-words',
            truncate && 'truncate',
            isSmall && 'mt-0.5',
            !isOption && 'max-w-64'
          )
        "
      >
        {{ name }}
      </p>
      <p
        :title="description"
        data-testid="group-info-block-description"
        :class="
          cn(
            'text-xs font-normal text-gray-600 break-words',
            truncate && 'truncate',
            !isSmall && 'mt-0.5',
            !isOption && 'max-w-64'
          )
        "
      >
        {{ description || '-' }}
      </p>
    </div>
    <slot></slot>
  </div>
</template>
